/* eslint-disable jsx-a11y/no-distracting-elements */
import React, { Component } from 'react'
import { Container, Collapse, Nav, Navbar,
    NavbarToggler, NavbarBrand, NavItem, NavLink,
    UncontrolledDropdown, DropdownToggle, DropdownMenu, Dropdown,
    DropdownItem, Table, ButtonDropdown, Input, Button,
    Modal, ModalHeader, ModalBody, ModalFooter, Alert, Spinner} from 'reactstrap'
import logo from "../../assets/img/logo.png"
import style from '../../assets/css/input.module.css'
import {FaSearch, FaUserCircle, FaBars} from 'react-icons/fa'
import {AiOutlineFileExcel, AiFillCheckCircle, AiOutlineInbox, AiOutlineClose} from 'react-icons/ai'
import {Formik} from 'formik'
import * as Yup from 'yup'
import setting_disposal from '../../redux/actions/setting_disposal'
import {connect} from 'react-redux'
import auth from '../../redux/actions/auth'
import {default as axios} from 'axios'
import Sidebar from "../../components/Header";
import MaterialTitlePanel from "../../components/material_title_panel";
import SidebarContent from "../../components/sidebar_content";
import NavBar from '../../components/NavBar'
import ExcelJS from "exceljs"
import fs from "file-saver"
import moment from 'moment'
import styleTrans from '../../assets/css/transaksi.module.css'
import NewNavbar from '../../components/NewNavbar'
const {REACT_APP_BACKEND_URL} = process.env

const settingDisposalSchema = Yup.object().shape({
    name: Yup.string().required('must be filled'),
    type_disposal: Yup.string().required('must be filled'),
    flow: Yup.string().required('must be filled')
});

class SettingDisposal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            docked: false,
            open: false,
            transitions: true,
            touch: true,
            shadow: true,
            pullRight: false,
            touchHandleWidth: 20,
            dragToggleDistance: 30,
            alert: false,
            confirm: "",
            isOpen: false,
            dropOpen: false,
            dropOpenNum: false,
            value: '',
            onChange: new Date(),
            sidebarOpen: false,
            modalAdd: false,
            modalEdit: false,
            modalUpload: false,
            modalDownload: false,
            modalConfirm: false,
            detail: {},
            upload: false,
            errMsg: '',
            fileUpload: '',
            limit: 'all',
            search: '',
            selectMonth: moment().month() + 1,
            selectYear: moment().year(),
            listSettingDisposal: [],
            tipeModal: 'add',
            openDelete: false
        }
        this.onSetOpen = this.onSetOpen.bind(this);
        this.menuButtonClick = this.menuButtonClick.bind(this);
    }

    prosesSidebar = (val) => {
        this.setState({sidebarOpen: val})
    }
    
    goRoute = (val) => {
        this.props.history.push(`/${val}`)
    }

    chekApp = (val) => {
        const { listSettingDisposal } = this.state
        const {dataSettingDisposal} = this.props.setting_disposal
        if (val === 'all') {
            const data = []
            for (let i = 0; i < dataSettingDisposal.length; i++) {
                data.push(dataSettingDisposal[i].id)
            }
            this.setState({listSettingDisposal: data})
        } else {
            listSettingDisposal.push(val)
            this.setState({listSettingDisposal: listSettingDisposal})
        }
    }

    chekRej = (val) => {
        const {listSettingDisposal} = this.state
        if (val === 'all') {
            const data = []
            this.setState({listSettingDisposal: data})
        } else {
            const data = []
            for (let i = 0; i < listSettingDisposal.length; i++) {
                if (listSettingDisposal[i] === val) {
                    data.push()
                } else {
                    data.push(listSettingDisposal[i])
                }
            }
            this.setState({listSettingDisposal: data})
        }
    }

    next = async () => {
        const { page } = this.props.setting_disposal
        const token = localStorage.getItem('token')
        await this.props.nextPage(token, page.nextLink)
    }

    prev = async () => {
        const { page } = this.props.setting_disposal
        const token = localStorage.getItem('token')
        await this.props.nextPage(token, page.prevLink)
    }

    showAlert = () => {
        this.setState({alert: true, modalEdit: false, modalAdd: false, modalUpload: false })
       
         setTimeout(() => {
            this.setState({
                alert: false
            })
         }, 10000)
    }

    uploadAlert = () => {
        this.setState({upload: true, modalUpload: false })
       
         setTimeout(() => {
            this.setState({
                upload: false
            })
         }, 10000)
    }

    openConfirm = () => {
        this.setState({modalConfirm: !this.state.modalConfirm})
    }

    ExportMaster = () => {
        const token = localStorage.getItem('token')
        this.props.exportMaster(token)
    }

    toggle = () => {
        this.setState({isOpen: !this.state.isOpen})
    }

    dropDown = () => {
        this.setState({dropOpen: !this.state.dropOpen})
    }
    dropOpen = () => {
        this.setState({dropOpenNum: !this.state.dropOpenNum})
    }
    onSetSidebarOpen = () => {
        this.setState({ sidebarOpen: !this.state.sidebarOpen });
    }
    openModalAdd = () => {
        this.setState({modalAdd: !this.state.modalAdd})
    }
    openModalEdit = () => {
        this.setState({modalEdit: !this.state.modalEdit})
    }
    openModalUpload = () => {
        this.setState({modalUpload: !this.state.modalUpload})
    }
    openModalDownload = () => {
        this.setState({modalUpload: !this.state.modalUpload})
    }

    prosesOpen = (val) => {
        if (val === 'add') {
            this.setState({tipeModal: val})
            this.openModalEdit()
        } else {
            this.setState({
                tipeModal: 'edit', 
                detail: val, 
                selectYear: moment(val.periode).year(), 
                selectMonth: moment(val.periode).month() + 1
            })
            console.log(moment(val.periode).month())
            console.log(moment(val.periode).year())
            setTimeout(() => {
                this.openModalEdit()
            }, 100)
        }
    }

    prosesOpenDelete = (val) => {
        this.setState({detail: val})
        this.openModalDelete()
    } 

    openModalDelete = () => {
        this.setState({openDelete: !this.state.openDelete})
    }

    prosesDelete = async () => {
        const token = localStorage.getItem("token")
        const {detail} = this.state
        await this.props.deleteSettingDisposal(token, detail.id)
        this.setState({confirm: 'delete'})
        this.openConfirm()
        this.openModalDelete()
        setTimeout(() => {
            this.getDataSettingDisposal()
        }, 500)
    }

    handleMonth = (e) => {
        this.setState({ selectMonth: e.target.value });
    };

    handleYear = (e) => {
        this.setState({ selectYear: e.target.value });
    };

    addSettingDisposal = async (values) => {
        const token = localStorage.getItem("token")
        const { selectYear, selectMonth } = this.state
        await this.props.addSettingDisposal(token, values)
        this.setState({confirm: 'add'})
        this.openConfirm()
        this.openModalEdit()
        setTimeout(() => {
            this.getDataSettingDisposal()
        }, 100)
    }

    onChangeHandler = e => {
        const {size, type} = e.target.files[0]
        if (size >= 5120000) {
            this.setState({errMsg: "Maximum upload size 5 MB"})
            this.uploadAlert()
        } else if (type !== 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' && type !== 'application/vnd.ms-excel' ){
            this.setState({errMsg: 'Invalid file type. Only excel files are allowed.'})
            this.uploadAlert()
        } else {
            this.setState({fileUpload: e.target.files[0]})
        }
    }

    uploadMaster = async () => {
        const token = localStorage.getItem('token')
        const data = new FormData()
        data.append('master', this.state.fileUpload)
        await this.props.uploadMaster(token, data)
    }

    editSettingDisposal = async (values, id) => {
        const token = localStorage.getItem("token")
        const { selectYear, selectMonth } = this.state
        await this.props.updateSettingDisposal(token, id, values)
        this.setState({confirm: 'edit'})
        this.openConfirm()
        this.getDataSettingDisposal()
        this.openModalEdit()
    }

    componentDidUpdate() {
        const {isError, isUpload, isExport} = this.props.setting_disposal
        // if (isError) {
        //     this.props.resetError()
        //     this.showAlert()
        // } else if (isUpload) {
        //     setTimeout(() => {
        //         this.props.resetError()
        //         this.setState({modalUpload: false})
        //      }, 2000)
        //      setTimeout(() => {
        //         this.getDataSettingDisposal()
        //      }, 2100)
        // } else if (isUpload === false) {
        //     this.props.resetError()
        //     this.setState({confirm: 'failUpload'})
        //     this.openConfirm()
        // } else if (isExport) {
        //     this.props.resetError()
        //     this.DownloadMaster()
        // }
    }

    DownloadMaster = () => {
        const {link} = this.props.setting_disposal
        axios({
            url: `${link}`,
            method: 'GET',
            responseType: 'blob', // important
        }).then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', "master setting disposal.xlsx"); //or any other extension
            document.body.appendChild(link);
            link.click();
        });
    }

    componentDidMount() {
        this.getDataSettingDisposal()
    }

    onSearch = (e) => {
        this.setState({search: e.target.value})
        if(e.key === 'Enter'){
            this.getDataSettingDisposal()
        }
    }

    getDataSettingDisposal = async (value) => {
        const token = localStorage.getItem("token")
        const { page } = this.props.setting_disposal
        const search = this.state.search
        const limit = this.state.limit
        await this.props.getSettingDisposal(token, search, limit, page.currentPage)
    }

    menuButtonClick(ev) {
        ev.preventDefault();
        this.onSetOpen(!this.state.open);
    }

    onSetOpen(open) {
        this.setState({ open });
    }

    render() {
        const {dropOpen, detail, upload, errMsg, listSettingDisposal, tipeModal, selectMonth, selectYear} = this.state
        const {dataSettingDisposal, isGet, alertM, alertMsg, alertUpload, page } = this.props.setting_disposal
        const { statusDisposal, flowDisposal } = this.props.disposal
        const level = localStorage.getItem('level')
        const names = localStorage.getItem('name')
        const months = moment.locale("id") && moment.months();
        const currentYear = moment().year(); 
        const days = Array.from({ length: 31 }, (_, i) => i + 1)
        const years = [];

        for (let year = 2000; year <= currentYear; year++) {
            years.push(year);
        }

        console.log(selectMonth)
        console.log(selectYear)

        const contentHeader =  (
            <div className={style.navbar}>
                <NavbarBrand
                    href="#"
                    onClick={this.menuButtonClick}
                    >
                        <FaBars size={20} className={style.white} />
                    </NavbarBrand>
                    <Navbar />
            </div>
        )

        const sidebar = <SidebarContent />
        const sidebarProps = {
            sidebar,
            docked: this.state.docked,
            sidebarClassName: "custom-sidebar-class",
            contentId: "custom-sidebar-content-id",
            open: this.state.open,
            touch: this.state.touch,
            shadow: this.state.shadow,
            pullRight: this.state.pullRight,
            touchHandleWidth: this.state.touchHandleWidth,
            dragToggleDistance: this.state.dragToggleDistance,
            transitions: this.state.transitions,
            onSetOpen: this.onSetOpen
          };
        return (
            <>
                <div className={styleTrans.app}>
                    <NewNavbar handleSidebar={this.prosesSidebar} handleRoute={this.goRoute} />

                    <div className={`${styleTrans.mainContent} ${this.state.sidebarOpen ? styleTrans.collapsedContent : ''}`}>
                        <h2 className={styleTrans.pageTitle}>Setting Disposal</h2>
                        
                        <div className={styleTrans.searchContainer}>
                            <div className='rowCenter'>
                                <Button onClick={() => this.prosesOpen('add')} color="primary" size="lg" className='mr-1'>Add</Button>
                                {/* <Button onClick={() => this.openModalUpload()} color="success" size="lg" className='mr-1'>Upload</Button> */}
                            </div>
                            <div className={style.searchEmail2}>
                                <text>Search: </text>
                                <Input 
                                className={style.search}
                                onChange={this.onSearch}
                                value={this.state.search}
                                onKeyPress={this.onSearch}
                                >
                                    <FaSearch size={20} />
                                </Input>
                            </div>
                        </div>

                        <table className={`${styleTrans.table} ${dataSettingDisposal.length > 0 ? styleTrans.tableFull : ''}`}>
                            <thead>
                                <tr>
                                    <th>NO</th>
                                    <th>Name</th>
                                    <th>Type Disposal</th>
                                    <th>Flow Disposal</th>
                                    <th>Opsi</th>
                                </tr>
                            </thead>
                            <tbody>
                                {dataSettingDisposal.length !== 0 && dataSettingDisposal.map((item, index) => {
                                    return (
                                        <tr>
                                            <td>{index + 1}</td>
                                            <td>{item.name}</td>
                                            <td>{item.type_disposal}</td>
                                            <td>{item.flow}</td>
                                            <td>
                                                <Button className='ml-1 mt-1' onClick={() => this.prosesOpen(item)} color='success'>
                                                    Edit
                                                </Button>
                                                <Button className='ml-1 mt-1' onClick={() => this.prosesOpenDelete(item)} color='danger'>
                                                    Delete
                                                </Button>
                                            </td>
                                        </tr>
                                    )
                                })}
                            </tbody>
                        </table>
                        {dataSettingDisposal.length === 0 && (
                            <div className={style.spinCol}>
                                <AiOutlineInbox size={50} className='mb-4' />
                                <div className='textInfo'>Data setting disposal tidak ditemukan</div>
                            </div>
                        )}
                          <div>
                              <div className={style.infoPageEmail1}>
                                  <text>Showing {page.currentPage} of {page.pages} pages</text>
                                  <div className={style.pageButton}>
                                      <button className={style.btnPrev} color="info" disabled={page.prevLink === null ? true : false} onClick={this.prev}>Prev</button>
                                      <button className={style.btnPrev} color="info" disabled={page.nextLink === null ? true : false} onClick={this.next}>Next</button>
                                  </div>
                              </div>
                          </div>
                    </div>
                </div>
                <Modal toggle={this.openModalEdit} isOpen={this.state.modalEdit} size="lg">
                    <ModalHeader toggle={this.openModalEdit}>{tipeModal === 'add' ? 'Add' : 'Edit'} Data Setting Disposal</ModalHeader>
                    <Formik
                    initialValues={{
                        name: tipeModal === 'add' ? '' : detail.name === null ? '' : detail.name,
                        type_disposal: tipeModal === 'add' ? '' : detail.type_disposal === null ? '-' : detail.type_disposal,
                        flow: tipeModal === 'add' ? '' : detail.flow === null ? '-' : detail.flow
                    }}
                    validationSchema={settingDisposalSchema}
                    onSubmit={(values) => {tipeModal === 'add' ? this.addSettingDisposal(values) : this.editSettingDisposal(values, detail.id)}}
                    >
                        {({ handleChange, handleBlur, handleSubmit, values, errors, touched,}) => (
                        <>
                            <ModalBody>
                                <div className={style.addModalDepo}>
                                    <text className="col-md-4">
                                        Name
                                    </text>
                                    <div className="col-md-8">
                                        <Input 
                                        type="text" 
                                        name="name" 
                                        value={values.name}
                                        onChange={handleChange("name")}
                                        onBlur={handleBlur("name")}
                                        />
                                    </div>
                                </div>
                                <div className={style.addModalDepo}>
                                    <text className="col-md-4">
                                        Type Disposal
                                    </text>
                                    <div className="col-md-8">
                                        <Input 
                                        type="select" 
                                        name="type_disposal" 
                                        value={values.type_disposal}
                                        onChange={handleChange("type_disposal")}
                                        onBlur={handleBlur("type_disposal")}
                                        >
                                            <option>-Pilih Type Disposal-</option>
                                            {statusDisposal.length !== 0 && statusDisposal.filter(x => x.status === 'special').map(item => {
                                                return (
                                                    <option value={item.status}>{item.name}</option>
                                                )
                                            })}
                                        </Input>
                                    </div>
                                </div>
                                <div className={style.addModalDepo}>
                                    <text className="col-md-4">
                                        Flow Disposal
                                    </text>
                                    <div className="col-md-8">
                                        <Input 
                                        type="select" 
                                        name="flow" 
                                        value={values.flow}
                                        onChange={handleChange("flow")}
                                        onBlur={handleBlur("flow")}
                                        >
                                            <option>-Pilih Flow Disposal-</option>
                                            {flowDisposal.length !== 0 && flowDisposal.map(item => {
                                                return (
                                                    <option value={item.status}>{item.name}</option>
                                                )
                                            })}
                                        </Input>
                                    </div>
                                </div>
                            </ModalBody>
                            <ModalFooter>
                                <div></div>
                                <div>
                                    <Button className="mr-2" onClick={handleSubmit} color="primary">Save</Button>
                                    <Button className="mr-5" onClick={this.openModalEdit}>Cancel</Button>
                                </div>
                            </ModalFooter>
                        </>
                    )}
                    </Formik>
                </Modal>
                <Modal isOpen={this.state.openDelete} size="md" toggle={this.openModalDelete} centered={true}>
                    <ModalBody>
                        <div className={style.modalApprove}>
                            <div>
                                <text>
                                    Anda yakin untuk delete setting disposal ?
                                </text>
                            </div>
                            <div className={style.btnApproveIo}>
                                <Button color="primary" className='mr-2' onClick={this.prosesDelete}>Ya</Button>
                                <Button color="secondary" onClick={this.openModalDelete}>Tidak</Button>
                            </div>
                        </div>
                    </ModalBody>
                </Modal>
                <Modal toggle={this.openModalUpload} isOpen={this.state.modalUpload} >
                    <ModalHeader>Upload Master Setting Disposal</ModalHeader>
                    <ModalBody className={style.modalUpload}>
                        <div className={style.titleModalUpload}>
                            <text>Upload File: </text>
                            <div className={style.uploadFileInput}>
                                <AiOutlineFileExcel size={35} />
                                <div className="ml-3">
                                    <Input
                                    type="file"
                                    name="file"
                                    accept=".xls,.xlsx"
                                    onChange={this.onChangeHandler}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="itemCenter mt-4">
                            {/* <Button color="description" onClick={this.downloadTemplate}>Download Template</Button> */}
                            <Button 
                              className='mr-2 mt-4' 
                              color="primary" 
                              disabled={this.state.fileUpload === "" ? true : false } 
                              onClick={this.uploadMaster}>
                                Upload
                            </Button>
                            <Button className='mr-1 mt-4' onClick={this.openModalUpload}>Cancel</Button>
                        </div>
                    </ModalBody>
                </Modal>
                <Modal isOpen={this.state.modalConfirm} toggle={this.openConfirm} size="md">
                    <ModalBody>
                        {this.state.confirm === 'edit' ? (
                        <div className={style.cekUpdate}>
                            <AiFillCheckCircle size={80} className={style.green} />
                            <div className={style.sucUpdate}>Berhasil Memperbarui Setting Disposal</div>
                        </div>
                        ) : this.state.confirm === 'add' ? (
                            <div className={style.cekUpdate}>
                                    <AiFillCheckCircle size={80} className={style.green} />
                                <div className={style.sucUpdate}>Berhasil Menambahkan Setting Disposal</div>
                            </div>
                        ) : this.state.confirm === 'upload' ?(
                            <div>
                                <div className={style.cekUpdate}>
                                    <AiFillCheckCircle size={80} className={style.green} />
                                <div className={style.sucUpdate}>Berhasil Mengupload Master Setting Disposal</div>
                            </div>
                            </div>
                        ) : this.state.confirm === 'delete' ?(
                            <div>
                                <div className={style.cekUpdate}>
                                    <AiFillCheckCircle size={80} className={style.green} />
                                <div className={style.sucUpdate}>Berhasil Delete Setting Disposal</div>
                            </div>
                            </div>
                        ) : this.state.confirm === 'failUpload' ? (
                            <div>
                                <div className={style.cekUpdate}>
                                    <AiOutlineClose size={80} className={style.red} />
                                    <div className={[style.sucUpdate, style.green, style.mb4]}>Gagal Upload</div>

                                    {alertUpload !== undefined && alertUpload.length > 0 ? alertUpload.map(item => {
                                        return (
                                            <div className={[style.sucUpdate, style.green, style.mb3]}>{`${item}`}</div>
                                        )
                                    }) : (
                                        <div></div>
                                    )}
                                </div>
                            </div>
                        ) : (
                            <div></div>
                        )}
                    </ModalBody>
                </Modal>
                <Modal isOpen={this.props.setting_disposal.isLoading ? true: false} size="sm">
                        <ModalBody>
                        <div>
                            <div className={style.cekUpdate}>
                                <Spinner />
                                <div sucUpdate>Waiting....</div>
                            </div>
                        </div>
                        </ModalBody>
                </Modal>
                <Modal isOpen={this.props.setting_disposal.isUpload ? true: false} size="sm" toggle={() => this.props.resetError()}>
                        <ModalBody>
                        <div>
                            <div className={style.cekUpdate}>
                                <AiFillCheckCircle size={80} className={style.green} />
                                <div className={style.sucUpdate}>Berhasil Mengupload Master</div>
                            </div>
                        </div>
                        </ModalBody>
                </Modal>
            </>
        )
    }
}

const mapStateToProps = state => ({
    setting_disposal: state.setting_disposal,
    disposal: state.disposal
})

const mapDispatchToProps = {
    logout: auth.logout,
    addSettingDisposal: setting_disposal.addSettingDisposal,
    updateSettingDisposal: setting_disposal.updateSettingDisposal,
    getSettingDisposal: setting_disposal.getSettingDisposal,
    deleteSettingDisposal: setting_disposal.deleteSettingDisposal,
    resetError: setting_disposal.resetError,
    nextPage: setting_disposal.nextPage,
}

export default connect(mapStateToProps, mapDispatchToProps)(SettingDisposal)
